<template>
    <div v-show="popupOpen" id="popup">
        <div id="popup-scrim" @click="closePopup"></div>
        <div class="capper">
            <div class="capper-padded">
                <div id="popup-inner" :class="`st-${sectionType}`">
                    <div class="popup-section gallery" v-if="sectionType === 'gallery'">
                        <div @click="closePopup" class="close-button"></div>
                        <div v-if="sectionType === 'gallery'" id="popup-swiper-container" class="swiper-container">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide"
                                     v-for="(item, index) in filteredItems"
                                     :key="`gallery-${index}`"
                                >
                                    <div class="gallery-bg" :style="item.bgStyle"></div>
                                    <div v-if="item.caption" class="gallery-caption" v-html="item.caption"></div>
                                </div>
                            </div>
                            <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                            <!--<div class="swiper-pagination"></div>-->
                        </div>
                    </div>
                    <div class="popup-section youtube" v-show="sectionType === 'youtube'">
                        <div @click="closePopup" class="close-button"></div>
                        <div class="content-inner">
                            <div id="youtube-player"></div>
                        </div>
                    </div>
                    <div class="popup-section platforms" v-if="sectionType === 'platforms'">
                        <div class="platforms-inner">
                            <div @click="closePopup" class="close-button"></div>
                            <img v-if="obj?.gameLink?.gamesLogo?.[0]?.url" class="logo" :alt="obj?.gameLink?.gamesLogo?.[0]?.title" :src="obj?.gameLink?.gamesLogo?.[0]?.url"/>
                            <Lines type="center" label="PLATFORMS"/>
                            <div class="platform-icons">
                                <div
                                    class="platform-icon"
                                    v-for="(pItem, pIndex) in obj?.gameLink?.platforms"
                                    :key="`picon-${pIndex}`"
                                >
                                    <component
                                        :is="pItem.platformLink?.url ? 'a' : 'span'"
                                        :href="pItem.platformLink?.url || null"
                                        :class="pItem.platformLink?.url ? 'imgover' : null"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img :alt="pItem.platformBug?.[0]?.platformIcon?.[0]?.title"  :src="pItem.platformBug?.[0]?.platformIcon?.[0]?.url" />
                                    </component>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import gh from '@/helpers/gh'
import gsap, { Power3 } from '@/plugins/gsap';
import Lines from "@/components/pieces/Lines";
import VueInlineSvg from "vue-inline-svg";
import Swiper, {Navigation, Pagination, Keyboard} from "swiper";
Swiper.use([Navigation, Pagination, Keyboard]);
export default {
    name: "PopupComponent",
    data() {
        return {
            window: window,
            isTransition: false,
            player: null,
            sectionType: null,
            slider: null,
        }
    },
    components: {
        VueInlineSvg,
        Lines
    },
    computed: {
        ...mapState({
            popupOpen: state => state.popupOpen,
            obj: state => state.popupObject,
        }),
        filteredItems() {
            return (this.obj?.items || []).filter(item => !!item.bgStyle);
        }
    },
    watch: {
        popupOpen(newVal) {
            if (newVal) {
                this.reveal()
            } else {
                this.unreveal()
            }
        }
    },
    mounted() {
        this.window.addEventListener('keyup', this.detectEscapeKey)
    },
    beforeUnmount() {
        this.window.removeEventListener('keyup', this.detectEscapeKey)
    },
    methods: {
        detectEscapeKey(e) {
            // Only act if the popup is open.
            if (!this.popupOpen) return;
            if (e.keyCode === 27) {
                e.preventDefault();
                e.stopPropagation();
                this.closePopup();
            }
        },
        reveal() {
            if (!this.isTransition) {
                this.isTransition = true

                if (this.obj) {
                    if (this.obj.youtubeId) {
                        if (this.player) {
                            this.player.loadVideoById(this.obj.youtubeId)
                        } else {
                            this.createYoutubePlayer()
                        }
                        this.sectionType = 'youtube'
                    } else if (this.obj.platforms) {
                        this.sectionType = 'platforms'
                    } else if (this.obj.gallery) {
                        this.sectionType = 'gallery'
                        setTimeout(this.initGallery, 50)
                    }
                }

                gh.enableBodyScroll(false)
                let tl = gsap.timeline({})

                tl.fromTo('#popup-scrim', 0.35,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        ease: Power3.easeOut,
                    },
                    0
                )
                tl.fromTo('#popup-inner', 0.35,
                    { opacity: 0 },
                    {
                        opacity: 1,
                        ease: Power3.easeOut,
                        onComplete: this.reveal2
                    },
                    0
                )
            }
        },
        reveal2() {
            this.isTransition = false
        },
        closePopup() {
            if (!this.isTransition) {
                this.isTransition = true
                this.unreveal()
            }
        },
        unreveal() {
            let tl = gsap.timeline({})
            tl.fromTo('#popup-scrim', 0.25,
                { opacity: 1 },
                {
                    opacity: 0,
                    ease: Power3.easeIn,
                },
                0
            )
            tl.fromTo('#popup-inner', 0.25,
                { opacity: 1 },
                {
                    opacity: 0,
                    ease: Power3.easeIn,
                    onComplete: this.unreveal2
                },
                0
            )
            gh.enableBodyScroll(true)
        },
        unreveal2() {
            if (this.player && typeof this.player.stopVideo === 'function') {
                this.player.stopVideo()
                this.player.destroy()
                this.player = null
            }
            this.isTransition = false
            this.$store.commit('closePopup')
            this.sectionType = null
        },
        createYoutubePlayer() {
            this.player = new this.window.YT.Player('youtube-player', {
                videoId: this.obj.youtubeId,
                host: "https://www.youtube-nocookie.com",
                playerVars: {
                    autoplay: 1,
                    modestbranding: 1,
                    rel: 0,
                    controls: 1
                },
                events: {
                    onStateChange: (event) => {
                        if (event.data === this.window.YT.PlayerState.PLAYING) {
                            if (!(this.popupOpen && this.obj && this.obj.youtubeId)) {
                                this.player.stopVideo();
                            }
                        }
                    }
                }
            })
        },
        initGallery() {
            const sel = '#popup-swiper-container'
            gsap.set(sel, { opacity: 0 })

            // Check if there's only one item
            const isSingle = this.filteredItems === 1;

            this.slider = new Swiper(sel, {
                init: false,
                speed: 750,
                // Only allow grabCursor if there are multiple slides
                grabCursor: !isSingle,
                // Disable loop for a single slide
                loop: !isSingle,
                initialSlide: this.obj.startingIndex,
                slidesPerView: 1,
                // Disable touch movement if only one slide is present
                allowTouchMove: !isSingle,
                // Only add navigation arrows if not a single slide
                navigation: isSingle ? {} : {
                    nextEl: sel + ' .swiper-button-next',
                    prevEl: sel + ' .swiper-button-prev'
                },
                // Only add pagination if not a single slide
                // pagination: isSingle ? {} : {
                //     el: sel + ' .swiper-pagination',
                //     type: 'bullets',
                //     clickable: true,
                // },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
            });

            this.slider.init()
            gsap.fromTo(sel,
                { opacity: 0 },
                { opacity: 1, delay: 0, duration: 0.5, ease: Power3.easeOut }
            );
        }
    }
}
</script>
